import { Message, Notification } from 'element-ui'
import store from '../store/index'
export function errorMessage(message = 'Error') {
  Message.error({
    showClose: true,
    message: message || 'error',
    type: 'error',
    duration: 4000,
  })
}
export function successMessage(
  message = 'Success',
  type = 'success',
  customClass
) {
  Notification({
    showClose: true,
    iconClass: '',
    message,
    type,
    customClass,
    duration: 4000,
  })
}

export const deepCopy = (value) => {
  return JSON.parse(JSON.stringify(value))
}

export const transformBoolValuesToInt = (payload) => {
  Object.keys(payload).forEach((key) => {
    if (typeof payload[key] === 'object' && payload[key]) {
      //if nested object
      transformBoolValuesToInt(payload[key])
      return
    }
    if (typeof payload[key] === 'boolean')
      payload[key] ? (payload[key] = 1) : (payload[key] = 0)
  })
  return payload
}
export const removeEmpty = (obj) => {
  return Object.entries(obj)
    .filter(([_, v]) => v != null && v !== '')
    .reduce(
      (acc, [k, v]) => ({ ...acc, [k]: v === Object(v) ? removeEmpty(v) : v }),
      {}
    )
}
export function countdown(minutes) {
  var seconds = 60
  var mins = minutes
  function tick() {
    //This script expects an element with an ID = "counter-code". You can change that to what ever you want.
    var counter = document.getElementById('counter-code')
    var current_minutes = mins - 1
    seconds--
    counter.innerHTML =
      current_minutes.toString() +
      ':' +
      (seconds < 10 ? '0' : '') +
      String(seconds)
    if (seconds > 0) {
      setTimeout(tick, 1000)
    } else {
      if (mins > 1) {
        countdown(mins - 1)
      }
    }
  }
  tick()
}
export const convertedPrice = ({ start, end }) => {
  const usdCourse = store.getters.getUsdCourse
  const currency = store.getters.getGlobalCurrency
  return {
    start: currency === 'usd' ? start : Math.floor(start / usdCourse),
    end: currency === 'usd' ? end : Math.floor(end / usdCourse),
  }
}
export const checkAuth = (showLoginModal = false) => {
  const isAuthUser = !!localStorage.getItem('token')
  if (!isAuthUser && showLoginModal) {
    store.commit('setLoginModalVisibility', true)
  }
  return isAuthUser
}
